import { render, staticRenderFns } from "./AppAdminNavDrawer.vue?vue&type=template&id=2d283a8f&scoped=true&"
import script from "./AppAdminNavDrawer.vue?vue&type=script&lang=js&"
export * from "./AppAdminNavDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AppAdminNavDrawer.vue?vue&type=style&index=0&id=2d283a8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d283a8f",
  null
  
)

export default component.exports